// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockWrapper_wrapper__3KdQg"};